module.exports = __webpack_public_path__ + "fonts/social.d8d9a9a.eot";